import { render, staticRenderFns } from "./ProjectConnect.vue?vue&type=template&id=e07ffa8c&scoped=true"
import script from "./ProjectConnect.vue?vue&type=script&lang=js"
export * from "./ProjectConnect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e07ffa8c",
  null
  
)

export default component.exports